import { render, staticRenderFns } from "./ApiUsersIndex.vue?vue&type=template&id=65d407a6"
import script from "./ApiUsersIndex.vue?vue&type=script&lang=js"
export * from "./ApiUsersIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports